/* original source: https://ui.shadcn.com/docs/components/collapsible */

'use client'
import { Button, RotatingChevron } from './Button'
import type { ButtonProps } from './Button'
import { cn } from '@joyful/utils'
import { Collapsible as CollapsiblePrimitive } from 'radix-ui'
import type { ComponentProps, ReactNode } from 'react'
export function Collapsible({
  ...props
}: ComponentProps<typeof CollapsiblePrimitive.Root>) {
  return <CollapsiblePrimitive.Root data-slot="collapsible" {...props} />
}

export function CollapsibleTrigger({
  ...props
}: ComponentProps<typeof CollapsiblePrimitive.CollapsibleTrigger>) {
  return (
    <CollapsiblePrimitive.CollapsibleTrigger
      data-slot="collapsible-trigger"
      {...props}
    />
  )
}

export interface CollapsibleContentProps extends ComponentProps<
  typeof CollapsiblePrimitive.CollapsibleContent
> {
  animationVariant?: 'none' | 'default' | 'slow'
}

export function CollapsibleContent({
  animationVariant = 'default',
  className,
  ...props
}: CollapsibleContentProps) {
  return (
    <CollapsiblePrimitive.CollapsibleContent
      className={cn(
        animationVariant === 'default' &&
          'data-[state=closed]:animate-collapse-up data-[state=open]:animate-collapse-down',
        animationVariant === 'slow' &&
          'motion-safe:data-[state=closed]:animate-collapse-up-slow motion-safe:data-[state=open]:animate-collapse-down-slow',
        'overflow-hidden',
        className,
      )}
      data-slot="collapsible-content"
      {...props}
    />
  )
}

export interface CollapsibleButtonProps extends ButtonProps {
  children: ReactNode
}

export function CollapsibleButton(props: CollapsibleButtonProps) {
  return (
    <div className="self-start">
      <Button
        size="sm"
        variant="ghost"
        colorVariant="emphasis"
        endIcon={
          <RotatingChevron
            className="size-2.5 fill-current stroke-2"
            orientation="horizontal"
          />
        }
        {...props}
      />
    </div>
  )
}
